import { render, staticRenderFns } from "./discapacidad-propietario.vue?vue&type=template&id=0402fd68&"
import script from "./discapacidad-propietario.vue?vue&type=script&lang=js&"
export * from "./discapacidad-propietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports